// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sessionview {
  position: fixed;
  height: 100%;
  width: 100%;
  padding: 0;
  margin: 0;
  z-index: 1;
  display: flex;
  flex-direction: row;
}

.sessionview-content {
  flex-grow: 1;
  background-color: var(--blue-background-color);
  position: relative;
  transition: all 0.5s ease-out;
}

.sessionview-central-column {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.sessionview-slide-menu-separator {
  height: var(--input-element-height);
  width: 3px;
  background-color: var(--text-contrast-color);
}

.sessionview-slide-menu-sessionname {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 var(--overlay-panel-element-gap);

  > h2 {
    margin: 0;
    text-align: center;
  }
}

.sessionview-dialogs {
  position: relative;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;

  > * {
    pointer-events: auto;
  }
}

.sessionview-transparent-overlay {
  font-size: var(--font-size-l);
  opacity: 0;
  transition: all 0.5s ease-out 0s;
  pointer-events: none;
  z-index: 1;
}

.sessionview-history-overlay {
  position: absolute;
  left: calc(var(--dialog-padding) / 2);
  bottom: calc(var(--dialog-padding) / 2);
}

.sessionview-bottom-right-controls {
  position: absolute;
  bottom: calc(var(--dialog-padding) / 2);
  right: calc(var(--dialog-padding) / 2);
  display: flex;
  flex-direction: column;
  gap: var(--dialog-element-gap);
  align-items: flex-end;

  > .webcam-preview-container {
    max-width: 240px;
  }
}

.sessionview-interaction-controls {
  min-width: var(--side-panel-min-width);
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--dialog-element-gap);
  justify-content: flex-end;
}

.sessionview-transparent-overlay-visible {
  opacity: 1;
  pointer-events: none;
  transition: all 0.5s ease-out 0.5s;
}

.sessionview-interaction-controls button {
  background-color: var(--dialog-background-color);
}

.leave-vr-button {
  background-color: aliceblue;
}

.vr-controls {
  /* fixed (not absolute), because it's appended directly to <body> and must stay anchored
     to the viewport regardless of document scroll height/layout shifts while VR is active */
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 99999;
  display: flex;
  gap: 8px;
}

.live-view-button {
  background-color: aliceblue;
}

.live-view-button-active {
  background-color: #b8f2c8;
}

.sessionview-object-popup {
  position: absolute;
  bottom: 0;
  right: 0;
  background: var(--dialog-background-color);
  border-top-left-radius: var(--dialog-border-radius);
  border-left: 1px solid var(--border-color);
  border-top: 1px solid var(--border-color);
  z-index: 1;
  pointer-events: all;
  max-width: 420px;
  min-width: 420px;
}

.sessionview-object-popup-standalone {
  right: 50%;
  transform: translateX(50%);
  border-top-right-radius: var(--dialog-border-radius);
}
`, "",{"version":3,"sources":["webpack://./src/ui/views/session-view/SessionView.component.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,UAAU;EACV,SAAS;EACT,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,8CAA8C;EAC9C,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,UAAU;EACV,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2CAA2C;;EAE3C;IACE,SAAS;IACT,kBAAkB;EACpB;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;;EAEX;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,6BAA6B;EAC7B,UAAU;EACV,gCAAgC;EAChC,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,qBAAqB;;EAErB;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,sCAAsC;EACtC,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;4FAC0F;EAC1F,eAAe;EACf,YAAY;EACZ,WAAW;EACX,cAAc;EACd,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,0CAA0C;EAC1C,mDAAmD;EACnD,0CAA0C;EAC1C,yCAAyC;EACzC,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,0BAA0B;EAC1B,oDAAoD;AACtD","sourcesContent":[".sessionview {\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  padding: 0;\n  margin: 0;\n  z-index: 1;\n  display: flex;\n  flex-direction: row;\n}\n\n.sessionview-content {\n  flex-grow: 1;\n  background-color: var(--blue-background-color);\n  position: relative;\n  transition: all 0.5s ease-out;\n}\n\n.sessionview-central-column {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.sessionview-slide-menu-separator {\n  height: var(--input-element-height);\n  width: 3px;\n  background-color: var(--text-contrast-color);\n}\n\n.sessionview-slide-menu-sessionname {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 0 var(--overlay-panel-element-gap);\n\n  > h2 {\n    margin: 0;\n    text-align: center;\n  }\n}\n\n.sessionview-dialogs {\n  position: relative;\n  top: 0;\n  left: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  width: 100%;\n\n  > * {\n    pointer-events: auto;\n  }\n}\n\n.sessionview-transparent-overlay {\n  font-size: var(--font-size-l);\n  opacity: 0;\n  transition: all 0.5s ease-out 0s;\n  pointer-events: none;\n  z-index: 1;\n}\n\n.sessionview-history-overlay {\n  position: absolute;\n  left: calc(var(--dialog-padding) / 2);\n  bottom: calc(var(--dialog-padding) / 2);\n}\n\n.sessionview-bottom-right-controls {\n  position: absolute;\n  bottom: calc(var(--dialog-padding) / 2);\n  right: calc(var(--dialog-padding) / 2);\n  display: flex;\n  flex-direction: column;\n  gap: var(--dialog-element-gap);\n  align-items: flex-end;\n\n  > .webcam-preview-container {\n    max-width: 240px;\n  }\n}\n\n.sessionview-interaction-controls {\n  min-width: var(--side-panel-min-width);\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: var(--dialog-element-gap);\n  justify-content: flex-end;\n}\n\n.sessionview-transparent-overlay-visible {\n  opacity: 1;\n  pointer-events: none;\n  transition: all 0.5s ease-out 0.5s;\n}\n\n.sessionview-interaction-controls button {\n  background-color: var(--dialog-background-color);\n}\n\n.leave-vr-button {\n  background-color: aliceblue;\n}\n\n.vr-controls {\n  /* fixed (not absolute), because it's appended directly to <body> and must stay anchored\n     to the viewport regardless of document scroll height/layout shifts while VR is active */\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  z-index: 99999;\n  display: flex;\n  gap: 8px;\n}\n\n.live-view-button {\n  background-color: aliceblue;\n}\n\n.live-view-button-active {\n  background-color: #b8f2c8;\n}\n\n.sessionview-object-popup {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  background: var(--dialog-background-color);\n  border-top-left-radius: var(--dialog-border-radius);\n  border-left: 1px solid var(--border-color);\n  border-top: 1px solid var(--border-color);\n  z-index: 1;\n  pointer-events: all;\n  max-width: 420px;\n  min-width: 420px;\n}\n\n.sessionview-object-popup-standalone {\n  right: 50%;\n  transform: translateX(50%);\n  border-top-right-radius: var(--dialog-border-radius);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
